export function replaceLastCommaWith(replacement) {
    const string = this || '';
    return string.replace(/(.*)(, )([^,]*$)/, `$1 ${replacement} $3`);
}
//# sourceMappingURL=replaceLastCommaWith.js.map